"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Gabe Kelley (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=8891%3A790))
 * @trackcomponent
 * @lastsynced 2025-07-07T16:19:10.633Z
 * @optimized using svgo:^3.0.2
 */
export const Slovenia = createSVGIcon(
  <>
    <path fill="#B64343" d="M1 1H17V13H1z" />
    <path fill="#64804E" d="M1 1H7V13H1z" />
    <path stroke="#757575" d="M1 1H17V13H1z" />
    <circle cx="6.5" cy="6.5" r="3" fill="#B64343" stroke="#FFD464" />
    <path d="M8 7c0 .552-.672 1-1.5 1S5 7.552 5 7V5h3z" fill="#fff" />
    <g clipPath="url(#clip0_8891_790)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 1v12h16V1z"
        fill="#2E42A5"
      />
      <mask
        id="mask0_8891_790"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 1v12h16V1z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0_8891_790)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 1v4h16V1z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 9v4h16V9z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.87 3.518s-1.052-.497-2.361-.497a6.1 6.1 0 0 0-2.362.497s.117 1.998.303 3.056c.079.452.458 1.11.802 1.422.392.355 1.257.777 1.257.777.25-.172.717-.25 1.315-.776.598-.527.746-1.423.746-1.423z"
          fill="#2E42A5"
        />
        <path
          d="m7.73 3.453.44.219-.302 3.011q-.158.956-.79 1.511-.317.282-.692.478c-.135.07-.7.361-.695.36a1 1 0 0 0-.135.075l-.055.037-.058-.028C4.858 8.83 4.31 8.446 4.04 8.2c-.37-.337-.761-1.025-.845-1.5-.124-.712-.236-1.692-.314-3.03l.393-.205c.078 1.327.172 2.384.294 3.082.073.415.433 1.048.762 1.346q.364.33 1.172.73.052-.031.108-.056c.001-.001.367-.164.494-.23q.35-.183.644-.445.56-.494.703-1.338z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.771 6.512s.095.292.272.62c.258.068.417.065.468.009.144-.162.66-.232.756-.093.059.085.268.144.496.066l-.026.005.19-.074.046-.019a.8.8 0 0 1 .214-.054.46.46 0 0 1 .24.048c.18.086.401.126.553.1.185-.322.316-.608.316-.608L6.42 5.67l-.349.378-.58-.826-.485.826-.372-.378zm.508.995a3 3 0 0 1-.115-.167c.224.04.377.019.462-.076.04-.045.159-.088.294-.107a.8.8 0 0 1 .17-.006.2.2 0 0 1 .05.01q.004.001 0-.005l-.001-.001c.103.148.384.227.65.131l-.026.005q.125-.042.247-.092l.016-.006a.6.6 0 0 1 .172-.045.3.3 0 0 1 .164.034c.159.076.332.118.508.122q-.052.084-.108.167c-.127.03-.323-.01-.481-.096a.38.38 0 0 0-.219-.05.6.6 0 0 0-.19.055l-.042.019c-.05.023-.13.06-.165.074l.03-.006c-.199.077-.373.02-.422-.062-.089-.146-.551-.075-.682.093-.035.045-.14.052-.312.009m.172.205.03.03c.451.44 1.01.656 1.01.656s.664-.201 1.041-.625q.05-.054.097-.117a1 1 0 0 1-.42-.123.23.23 0 0 0-.134-.032.5.5 0 0 0-.144.043l-.012.006c-.038.017-.155.07-.225.094l.029-.006c-.234.097-.482.02-.579-.125a.2.2 0 0 0-.038-.009.6.6 0 0 0-.144.006c-.115.018-.215.06-.248.103q-.084.105-.263.099"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.574 3.943h-.352l.273-.255-.273-.27h.352l.148-.262.15.262h.35l-.259.253.23.272h-.322l-.149.276zm1.656 0h-.35l.272-.255-.273-.27h.352l.148-.262.15.262h.35l-.259.253.23.272h-.322l-.149.276zm-.93.84H4.95l.272-.255-.272-.27H5.3l.149-.261.149.261h.35l-.258.254.23.272h-.322l-.15.276z"
          fill="#FECA00"
        />
      </g>
    </g>
  </>,
  "Slovenia",
  { fill: "none", viewBox: "0 0 18 14" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
